// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"255dd2b9","318":"97594ca2","484":"7269ffc2","569":"a482302c","604":"c04d1b22"}[chunkId] + ".chunk.css";
};